import { Component, Injectable, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SettingsService } from '../service/settings.service';
import { CommentsService } from '../service/comments.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { InterfacesDataDialogComponent } from '../interfaces-data-dialog/interfaces-data-dialog.component';
import { InterfacesCreateTokenDialogComponent } from '../interfaces-create-token-dialog/interfaces-create-token-dialog.component';
import { Functions, httpsCallable } from "@angular/fire/functions";
import { DeleteConfirmationDialogComponent } from '../delete-confirmation-dialog/delete-confirmation-dialog.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

  @Injectable()
  export class MyCustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();
    constructor(
      private translate: TranslateService
    ){}

    firstPageLabel = this.translate.instant("first_page");
    itemsPerPageLabel = this.translate.instant("items_page");
    lastPageLabel =this.translate.instant("last_page")
    nextPageLabel = this.translate.instant("next_page");
    previousPageLabel = this.translate.instant("previous_page");

    getRangeLabel(page: number, pageSize: number, length: number): string {
      if (length === 0) {
        return this.translate.instant("page1_1");
      }
      const amountPages = Math.ceil(length / pageSize);
      
      return this.translate.instant("page_of_1") + (page + 1) +this.translate.instant("page_of_2") + amountPages;
    }
  }

  @Component({
    selector: 'app-interfaces-list',
    templateUrl: './interfaces-list.component.html',
    styleUrls: ['./interfaces-list.component.css'],
    standalone: false
})
  export class InterfacesListComponent {
    allInterfaces:any
    allTokens:any
    emptyList=false
    deleteMode=false
    list:any
    link:string
    searchText = ''; 
    displayedInterfaceColumns: string[] = ['displayName', 'name', 'info', 'action'];
    displayedTokenColumns: string[] = ['displayName', 'creationDate', 'token', 'action'];
    listdata= new MatTableDataSource()
    tokenlistdata= new MatTableDataSource()
    @ViewChild('interfacesPaginator') interfacesPaginator!: MatPaginator;
    @ViewChild('tokensPaginator') tokensPaginator!: MatPaginator;
    @ViewChild('interfacesSort') interfacesSort!: MatSort;
    @ViewChild('tokensSort') tokensSort!: MatSort;
    paginatorSize = this.settingsService.paginator$
    interfacesUserRights_create:any
    interfacesUserRights_update:any
    interfacesUserRights_delete:any
    private destroy$ = new Subject<void>();

    constructor(private settingsService: SettingsService,
      public dialog: MatDialog,
      private commentService:CommentsService,
      private functions: Functions,
      private translate: TranslateService){}

      ngOnInit(): void {
        this.interfacesUserRights_create = this.settingsService.modulesRolesRights$.value['interfaces']['C']
        this.interfacesUserRights_update = this.settingsService.modulesRolesRights$.value['interfaces']['U']
        this.interfacesUserRights_delete = this.settingsService.modulesRolesRights$.value['interfaces']['D']

        this.settingsService.modulesRolesRights$.subscribe( value => {
          this.interfacesUserRights_create = this.settingsService.modulesRolesRights$.value['interfaces']['C']
          this.interfacesUserRights_update = this.settingsService.modulesRolesRights$.value['interfaces']['U']
          this.interfacesUserRights_delete = this.settingsService.modulesRolesRights$.value['interfaces']['D']
        })
        this.getInterfaces()
        this.getTokens()

        this.link = 'https://'+environment.urlHostName
        if(environment.useEmulators)
          this.link = 'http://localhost:5000'
      
        this.commentService.progressSpin.emit(true)
      }


      getInterfaces(){
        try{
          this.allInterfaces = this.settingsService.getAllInterfaces().pipe(takeUntil(this.destroy$)).subscribe( val => {
            this.allInterfaces = val
            // this.listdata.data = this.allInterfaces
            //this.listdata = new MatTableDataSource<any>(this.settingsService.settingsInterfaces)
            this.listdata = new MatTableDataSource<any>(this.allInterfaces);
            this.updateTable()
            if(this.allInterfaces.length==0){
              this.emptyList=true
            }
          })
        }catch(error){
          console.log(error)
          this.commentService.progressSpin.emit(false)
        }
      }

      getTokens(){
        try{
          this.settingsService.getAllTokens().pipe(takeUntil(this.destroy$)).subscribe( val => {
            this.allTokens = val
            this.tokenlistdata.data = this.allTokens
            //this.tokenlistdata = new MatTableDataSource<any>(this.settingsService.settingsTokens)
            this.tokenlistdata = new MatTableDataSource<any>(this.allTokens);
            this.tokenlistdata.sortingDataAccessor = (item: any, property: string) => {
              if (property === 'creationDate') {
                const d = item.creationDate?.toDate ? item.creationDate.toDate() : item.creationDate;
                return d instanceof Date ? d.getTime() : d ?? 0;
              }
              const v = item[property];
              return typeof v === 'string' ? v.toLowerCase() : v;
            };

            this.updateTable()
            if (this.allTokens.length==0){
              this.emptyList=true
            }
          })
        }catch(error){
          console.log(error)
          this.commentService.progressSpin.emit(false)
        }
      }

      applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.listdata.filter = filterValue.trim().toLowerCase();
    
        if (this.listdata.paginator) {
          this.listdata.paginator.firstPage();
        }
      }

      applyTokensFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.tokenlistdata.filter = filterValue.trim().toLowerCase();
    
        if (this.tokenlistdata.paginator) {
          this.tokenlistdata.paginator.firstPage();
        }
      }

      updateTable(){
        if(this.allInterfaces?.length!=0 ){
        this.listdata.paginator = this.interfacesPaginator;
        this.listdata.paginator.firstPage()
        this.listdata.sort = this.interfacesSort;
        this.commentService.progressSpin.emit(false)
        }

          if(this.allTokens?.length!=0){
            this.tokenlistdata.paginator = this.tokensPaginator;
            this.tokenlistdata.paginator.firstPage()
            this.tokenlistdata.sort = this.tokensSort;
            this.commentService.progressSpin.emit(false)
          }
      }

      openEditInterface(row){
        let dialogRef = this.dialog.open(InterfacesDataDialogComponent, {
          data: { 
            info:row,
            type: 'edit',
          },
          panelClass: 'custom-dialog-container',
          position: { right: '0'},
          enterAnimationDuration: '200ms',
          exitAnimationDuration: '200ms'
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if(result[1]){
            this.commentService.progressSpin.emit(true)
            setTimeout(() => {
              this.getInterfaces()
              this.commentService.progressSpin.emit(false)
            }, 1000);
          }
        });
      }

      openDialogNewInterface(){
        let dialogRef = this.dialog.open(InterfacesDataDialogComponent, {
          data: { 
            info:'',
            type: 'create',
          },
          panelClass: 'custom-dialog-container',
          position: { right: '0'},
          enterAnimationDuration: '200ms',
          exitAnimationDuration: '200ms'
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if(result[1]){
            this.commentService.progressSpin.emit(true)
            setTimeout(() => {
              this.getInterfaces()
              this.commentService.progressSpin.emit(false)
            }, 1000);
          }
        });
      }

      openDialogNewToken(){
        let dialogRef = this.dialog.open(InterfacesCreateTokenDialogComponent, {
          data: { 
            info:'',
            type: 'create',
          }
        });
    
        dialogRef.afterClosed().subscribe(result => { 
          if(result[1]){
            this.createNewToken(result[1].displayName)
          }
        });
      }

      createNewToken(displayName){
        this.commentService.progressSpin.emit(true)
        const now = new Date();
        const data = { 
          contextId: this.settingsService.contextId$,
          displayName: displayName,
          email: this.settingsService.settingsUserData$.email,
          timeStamp: now.toISOString()
        }
        const createAPIToken = httpsCallable(this.functions, 'admin-createAPIToken');
      
      createAPIToken(data).then((result) => {
        setTimeout(() => {
          this.getTokens();
          this.commentService.addSnackBar.emit(this.translate.instant('SnackBarConstants.TOKEN_CREATED'))
          this.commentService.progressSpin.emit(false)
        }, 1000);
      }).catch( error => {
        console.error('Error creating API token:', error);
        this.commentService.progressSpin.emit(false)
        const message = this.translate.instant('snackBarConstants.TOKEN_FAILED')
        this.commentService.addSnackBar.emit(message)
      })
    }

    deleteInterface(id){
      let dialogRef= this.dialog.open(DeleteConfirmationDialogComponent, {
        data: { 
          values:id,
          type:"Interface"
        },
      });
    
      dialogRef.afterClosed().subscribe(result => {
        this.commentService.progressSpin.emit(true)
        if(result[0]){
          setTimeout(() => {
            this.getInterfaces();
            this.commentService.progressSpin.emit(false)
          }, 1000);
        }else{
          const message = this.translate.instant("SnackBarConstants.DELETE_DISMISS")
          this.commentService.addSnackBar.emit(message)
        }
      });
    }

    deleteToken(token){
      let dialogRef= this.dialog.open(DeleteConfirmationDialogComponent, {
        data: { 
          values:token,
          type:"Token"
        },
      });
    
      dialogRef.afterClosed().subscribe(result => {
        this.commentService.progressSpin.emit(true)
        if(result[0]){
          setTimeout(() => {
            this.getTokens();
            this.commentService.progressSpin.emit(false)
          }, 1000);
        }else{
          const message = this.translate.instant("SnackBarConstants.DELETE_DISMISS")
          this.commentService.addSnackBar.emit(message)
        }
      });
    }


    copyToClipboard(token){
      navigator.clipboard.writeText(token).then(() => {
        this.commentService.addSnackBar.emit(this.translate.instant('SnackBarConstants.COPIED_TO_CLIPBOARD'))
      })
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

  }
